import _ from 'lodash';
import { DEFAULT_PREMIUM_FINANCING_PROFILE } from '../constants/premium-financing';

export const PREMIUM_FINANCING_PROFILE_COUNT = 12;

export const getDefaultPremiumFinancingProfile = () => {
  return _.cloneDeep(DEFAULT_PREMIUM_FINANCING_PROFILE);
};

export const getDefaultPremiumFinancingProfiles = (count = PREMIUM_FINANCING_PROFILE_COUNT) =>
  Array.from({ length: count }, () => getDefaultPremiumFinancingProfile());

/** Pad saved profiles up to the current supported count (e.g. 8 → 12). */
export const padPremiumFinancingProfiles = (profiles, count = PREMIUM_FINANCING_PROFILE_COUNT) => {
  const next = Array.isArray(profiles) ? profiles.slice() : [];
  while (next.length < count) {
    next.push(getDefaultPremiumFinancingProfile());
  }
  return next;
};

export const getPremiumFinancingProfileDisplay = (intl, profile, profileIndex) => {
  const defaultLabel = intl.formatMessage({ id: 'fin-py-ver' }, { index: profileIndex + 1 });
  return profile && profile.displayName ? profile.displayName : defaultLabel;
};
